import { useState } from "react";
import QRCode from "react-qr-code";
import { useNavigate } from "react-router-dom";
import { simpleGetter } from "../../../actions/common";
import { universalApi } from "../../../api/api";
import ArrowLeftWithBody from "../../../assets/icons/ArrowLeftWithBody";
import ArrowRight from "../../../assets/icons/ArrowRight";
import CheckMark from "../../../assets/icons/CheckMark";
import Delete from "../../../assets/icons/Delete";
import Dot from "../../../assets/icons/Dot";
import QR from "../../../assets/icons/QR";
import activityHours from "../../../assets/png/activity-hours.png";
import maleStudentProfile from "../../../assets/png/male-student-profile.png";
import roomStars from "../../../assets/svg/room-stars.svg";
import Modal from "../../../components/Modal/Modal";
import DefaultButton from "../../../components/default-button/DefaultButton";
import { useRooms } from "../../../hooks/cabinet";
import { showSnackbar } from "../../../misc/utils";

export const Cabinets = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [currentRoom, setCurrentRoom] = useState({});
  const [qrModalOpen, setQrModalOpen] = useState(false);
  const [createCabinetModaOpen, setCreateCabinetModaOpen] = useState(false);
  const [newCabinetName, setNewCabinetName] = useState("");
  const [triggerRoomsFetch, setTriggerRoomsFetch] = useState(0);
  const rooms = useRooms(search, triggerRoomsFetch);
  const onChangeInput = (e) => {
    setSearch(e.target.value);
  };

  const goToRoom = (roomId) => () => {
    navigate(`/admin/cabinets/${roomId}`);
  };

  const openQrModal = (room) => () => {
    setCurrentRoom(room);
    setQrModalOpen(true);
  };

  const onNewCabinetNameChange = (e) => {
    setNewCabinetName(e.target.value);
  };

  const toggelCreateCabinetModal = () => {
    setCreateCabinetModaOpen(!createCabinetModaOpen);
  };

  const onAdd = async () => {
    const response = await simpleGetter(universalApi.create, {
      model: "Room",
      body: {
        create: {
          name: newCabinetName,
          active: 1,
        },
      },
    });
    showSnackbar(
      response.item ? "Успешно" : "Произошла ошибка",
      response.item ? "success" : "error"
    );
    if (response.item) {
      setTriggerRoomsFetch((t) => t + 1);
      toggelCreateCabinetModal();
      setNewCabinetName("");
    }
  };

  const isAddDisabled = !newCabinetName;

  return (
    <div className="w-full h-full bg-[#f8f9fd] p-8 ">
      <div className="bg-white rounded-xl w-full h-full p-4">
        <div className="flex flex-row justify-between mb-4">
          <input
            className="bg-[#F0F3FA] text-[#1A1A1A] w-[200px] h-10 rounded-lg px-4 py-[10.5px]"
            placeholder="Поиск по кабинетам"
            value={search}
            onChange={onChangeInput}
          />
          <DefaultButton
            onClick={toggelCreateCabinetModal}
            additionalStyle='bg-valley-dark-green text-white px-3'
            buttonText='Создать кабинет'
          />
        </div>
        <div className="flex flex-row border-b border-b-[$F0F3FA] pt-2 pb-4">
          <div className="w-[17%] pl-2 flex flex-row justify-center">
            <span className="text-[#5F6B88] font-medium text-sm">Кабинет</span>
          </div>
          <div className="w-[15%] pl-2 flex flex-row">
            <span className="text-[#5F6B88] font-medium text-sm">
              Статус кабинета
            </span>
          </div>
          <div className="w-[6%] pl-2 flex flex-row justify-center ">
            <span className="text-[#5F6B88] font-medium text-sm">QR</span>
          </div>
          <div className="w-[19%] pl-2 flex flex-row">
            <span className="text-[#5F6B88] font-medium text-sm">
              Последний преподаватель
            </span>
          </div>
          <div className="w-[25%] pl-2 flex flex-row justify-center">
            <span className="text-[#5F6B88] font-medium text-sm">
              Часы активности
            </span>
          </div>
          <div className="w-[17%] pl-2 flex flex-row">
            <span className="text-[#5F6B88] font-medium text-sm">Рейтинг</span>
          </div>
        </div>
        <div className="overflow-scroll">
          {rooms.map((r, i) => (
            <div className="flex flex-row border-b border-b-[$F0F3FA] py-3">
              <div
                className="cursor-pointer w-[17%] pl-2 flex flex-row items-center"
                onClick={() => navigate(`/admin/cabinets/${r.id}`)}
              >
                <ArrowRight additionalStyle="text-blue-500" />
                <span className="ml-4 font-medium text-[15px] text-[#1A1A1A]">
                  {r.name}
                </span>
              </div>
              <div className="w-[15%] pl-2 flex flex-row items-center">
                <span className="text-[#5F6B88] font-medium text-sm">
                  {Boolean(r.lessons?.length) ? (
                    <div className="flex flex-row gap-1">
                      <Dot additionalStyle="text-green-500" />
                      <span className="ml-1 text-[15px] font-medium text-[#3BBC30]">
                        Активный
                      </span>
                    </div>
                  ) : (
                    <div className="flex flex-row gap-1">
                      <Dot additionalStyle="text-gray-300" />
                      <span className="ml-1 text-[15px] font-medium text-[#AFB7CA]">
                        Неактивный
                      </span>
                    </div>
                  )}
                </span>
              </div>
              <div className="w-[7%] pl-2 flex flex-row justify-center items-center">
                <DefaultButton
                  Icon={QR}
                  onClick={openQrModal(r)}
                  additionalStyle="bg-gray-100 text-gray-500 px-2"
                />
              </div>
              <div className="w-[19%] pl-2 flex flex-row items-center">
                {Boolean(r.lessons?.length) &&
                  Boolean(r.lessons.find((l) => Boolean(l.teacher_data))) && (
                    <div className="flex flex-row items-center">
                      <img src={maleStudentProfile} className="w-10 h-10" />
                      <span className="ml-3 text-[15px] font-medium text-[#1A1A1A]">
                        {
                          r.lessons.find((l) => Boolean(l.teacher_data))
                            .teacher_data.firstname
                        }{" "}
                        {
                          r.lessons.find((l) => Boolean(l.teacher_data))
                            .teacher_data.lastname
                        }
                      </span>
                    </div>
                  )}
              </div>
              <div className="w-[25%] pl-2 flex flex-row items-center justify-center">
                <img className="h-[58px]" src={activityHours} />
              </div>
              <div className="w-[17%] pl-2 flex flex-row">
                <img src={roomStars} />
                <div className="flex items-center">
                  <DefaultButton
                    Icon={Delete}
                    additionalStyle="ml-8 text-red-500 px-2 bg-red-50"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Modal
        dimensions="w-2/5 rounded-[10px] p-7"
        visible={qrModalOpen}
        setVisible={setQrModalOpen}
      >
        <div className="flex flex-row justify-center">
          <QRCode
            value={JSON.stringify({
              type: "CreateLesson",
              roomName: currentRoom.name,
              roomId: currentRoom.id,
            })}
          />
        </div>
      </Modal>
      <Modal
        visible={createCabinetModaOpen}
        setVisible={setCreateCabinetModaOpen}
        dimensions="w-2/5 h-1/3 rounded-xl"
      >
        <div className="flex flex-col p-2">
          <div className="flex flex-col px-6">
            <span className="text-2xl text-[#1A1A1A] mb-8">
              Название кабинета
            </span>
            <span className="font-medium text-sm text-[#5F6B88] mb-2">
              Курс
            </span>
            <input
              className="admin-input mb-8"
              value={newCabinetName}
              onChange={onNewCabinetNameChange}
            />
            <div className="flex flex-row">
              <button
                className={`rounded-lg flex-1 flex flex-row items-center justify-center bg-[#5F6B88] border py-3 mr-3`}
                onClick={toggelCreateCabinetModal}
              >
                <ArrowLeftWithBody additionalStyle="text-white" />
                <span className="ml-2 font-bold text-[15px] text-white">
                  Вернуться
                </span>
              </button>
              <button
                className={`rounded-lg flex-1 flex flex-row items-center justify-center bg-[#3BBC30] border py-3 ${isAddDisabled ? "opacity-30" : ""
                  }`}
                onClick={onAdd}
                disabled={isAddDisabled}
              >
                <CheckMark additionalStyle="text-white" />
                <span className="ml-2 font-bold text-[15px] text-white">
                  Создать класс
                </span>
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};
